/**
 * Web Vitals monitoring → dataLayer (GTM) for CWV reporting.
 * Pushes LCP, CLS, INP, FCP, TTFB.
 *
 * Requires nothing else; uses native PerformanceObserver. Lightweight (~1.5KB).
 * Designed for Core Web Vitals tracking in 2026 (INP replaced FID).
 */
(function() {
  if (typeof PerformanceObserver === 'undefined') return;
  var dl = window.dataLayer = window.dataLayer || [];

  function push(name, value, id) {
    var v = Math.round(name === 'CLS' ? value * 1000 : value);
    dl.push({
      event: 'web-vitals',
      'metric-name': name,
      'metric-value': v,
      'metric-id': id || Math.random().toString(36).slice(2),
      'metric-page': location.pathname,
    });
  }

  // LCP — Largest Contentful Paint
  try {
    var lcpVal = 0;
    var lcpObs = new PerformanceObserver(function(list) {
      var entries = list.getEntries();
      var last = entries[entries.length - 1];
      lcpVal = last.renderTime || last.loadTime || last.startTime;
    });
    lcpObs.observe({ type: 'largest-contentful-paint', buffered: true });
    addEventListener('visibilitychange', function() {
      if (document.visibilityState === 'hidden' && lcpVal) {
        push('LCP', lcpVal);
        lcpObs.disconnect();
      }
    });
  } catch (e) {}

  // CLS — Cumulative Layout Shift
  try {
    var clsVal = 0;
    var clsObs = new PerformanceObserver(function(list) {
      list.getEntries().forEach(function(e) {
        if (!e.hadRecentInput) clsVal += e.value;
      });
    });
    clsObs.observe({ type: 'layout-shift', buffered: true });
    addEventListener('visibilitychange', function() {
      if (document.visibilityState === 'hidden') {
        push('CLS', clsVal);
      }
    });
  } catch (e) {}

  // INP — Interaction to Next Paint (2026 CWV signal)
  try {
    var inpMax = 0;
    var inpObs = new PerformanceObserver(function(list) {
      list.getEntries().forEach(function(e) {
        if (e.duration > inpMax) inpMax = e.duration;
      });
    });
    inpObs.observe({ type: 'event', buffered: true, durationThreshold: 40 });
    addEventListener('visibilitychange', function() {
      if (document.visibilityState === 'hidden' && inpMax > 0) {
        push('INP', inpMax);
      }
    });
  } catch (e) {}

  // FCP + TTFB from Navigation Timing
  addEventListener('load', function() {
    setTimeout(function() {
      var nav = (performance.getEntriesByType('navigation') || [])[0];
      if (nav) {
        push('TTFB', nav.responseStart);
      }
      var fcp = (performance.getEntriesByName('first-contentful-paint') || [])[0];
      if (fcp) push('FCP', fcp.startTime);
    }, 0);
  });
})();
